import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Text,
  VStack,
  Heading,
  Divider,
  HStack,
  ButtonGroup,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import styles from "../Ace.module.css";
import { connect } from "react-redux";
import { Resize1, Resize2 } from "../icons";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";

const EditCorrections = (props) => {
  // const [final, setFinal] = useState([]);
  const [openGroups, setOpenGroups] = useState({});

  const toggleGroup = (name) => {
    setOpenGroups((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  let moveToPosition = function (a) {
    if (!a.endCol) {
      props.ace.current.editor.gotoLine(a.startRow + 1, a.startCol);
    } else {
      props.ace.current.editor.session.selection.setRange({
        start: { row: a.startRow, column: a.startCol },
        end: { row: a.endRow, column: a.endCol },
      });
    }
    props.ace.current.editor.scrollToLine(a.startRow, true);
  };

  const acceptChanges = (a, i) => {
    if (a.className.indexOf("Ace_deleted_marker") === 0) {
      let text = document.querySelector(".text");
      text.classList.add(styles.accepted_text);
    }
  };

  const acceptCorrections = (items, all = false) => {
    let arr = items.map((i) => i.data);

    props.acceptCorrections({ key: items[0].key, data: arr });
    if (props.corrections?.[items[0].key]?.length === 1) {
      props.editToolRemove({ key: items[0].key });
    }

    if (all) {
      props.editToolRemove({ key: items[0].key });
    }
  };

  const declineCorrections = (items, reject = false) => {
    let arr = items.map((i) => i.data);

    props.declineCorrections({ key: items[0].key, data: arr });
    if (props.corrections?.[items[0].key]?.length === 1) {
      props.editToolRemove({ key: items[0].key });
    }
    if (reject) {
      props.toolReject({ key: props.currentClient, data: items[0].key });
      props.editToolRemove({ key: items[0].key });
    }
  };

  const handleClose = () => {
    props.editToolAction({});
    props.toolStyles({ key: null, data: [], isChecked: false });
    props.editToolRejected();
  };
  console.log(props.states, "states");

  const final = useMemo(() => {
    if (!props.corrections) return [];

    const allCorrections = Object.values(props.corrections).flat();

    const rejected = props.rejected || [];

    return allCorrections.filter(
      (item1) =>
        !rejected?.some((item2) => item2.startRow === item1.data?.startRow)
    );
  }, [props.corrections, props.rejected]);

  return (
    <>
      <div className={styles.header}>
        <HStack
          backgroundColor="var(--primary-main)"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1">
            {/* <Tooltip label="Suggestions"> */}
            <Button
              // onClick={() => {
              //   setToggle(true);
              // }}
              // bg="#222"
              color="white"
              size="lg"
              colorScheme="#f47c0d"
              aria-label="Zoom-Out"
              // _hover={{ bg: "#222" }}
            >
              Suggestions
            </Button>
            {/* </Tooltip> */}
            <Box></Box>

            <Box display="flex" position={"absolute"} right={0}>
              <Button
                onClick={() => {
                  handleClose();
                }}
                color="white"
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "var(--secondary-main)" }}
              >
                Clear All
              </Button>
              {props.pdfFull ? (
                <Tooltip label="Minimize ">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                    }}
                    size="lg"
                    bg="var(--primary-main)"
                    aria-label="Resize"
                    icon={<Resize2 />}
                    _hover={{ bg: "var(--secondary-main)" }}
                  ></IconButton>
                </Tooltip>
              ) : (
                <Tooltip label="Maximize ">
                  <IconButton
                    onClick={() => {
                      props.toggleEditor();
                      // setClientWidth(1);
                    }}
                    size="lg"
                    colorScheme="#f47c0d"
                    aria-label="Resize "
                    icon={<Resize1 />}
                    bg="var(--primary-main)"
                    _hover={{ bg: "var(--secondary-main)" }}
                  ></IconButton>
                </Tooltip>
              )}
            </Box>
          </ButtonGroup>
        </HStack>
      </div>
      <VStack
        overflowY="auto"
        overflowX="hidden"
        height="84vh"
        gap="0"
        scrollbar-width="thin"
      >
        {final && final.length > 0 ? (
          Object.entries(
            final.reduce((acc, item) => {
              if (!acc[item.name]) acc[item.name] = [];
              acc[item.name].push(item);
              return acc;
            }, {})
          ).map(([name, items], groupIndex) => (
            <div key={groupIndex} style={{ width: "100%" }}>
              <Box borderRadius="md">
                {/* Group Header with common accept/reject */}
                <HStack
                  backgroundColor="#F5F5F5"
                  justifyContent="space-between"
                  alignItems="center"
                  borderBottom="1px solid #e2e8f0"
                  px="4"
                  py="3"
                  cursor="pointer"
                  onClick={() => toggleGroup(groupIndex)}
                >
                  <HStack gap="2" alignItems="center">
                    {openGroups[groupIndex] ? (
                      <ChevronDownIcon
                        w={6}
                        h={6}
                        marginTop="2px"
                        color="black"
                      />
                    ) : (
                      <ChevronRightIcon
                        w={6}
                        h={6}
                        marginTop="2px"
                        color="black"
                      />
                    )}
                    <Text fontSize="17px" fontWeight="medium" color="black">
                      {name}
                    </Text>
                  </HStack>
                  {/* <Text fontSize="18px" fontWeight="medium" color="black">
                    {name}
                  </Text> */}
                  <HStack gap="8px" paddingRight="20px">
                    <Button
                      display="flex"
                      gap="8px"
                      borderRadius="8px"
                      padding="10px 12px"
                      variant="outline"
                      backgroundColor="white"
                      border="1px solid #E0DBD7"
                      size="sm"
                      color="#504C4A"
                      onClick={() => acceptCorrections(items, true)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13.3337 4L6.00033 11.3333L2.66699 8"
                          stroke="#208923"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Accept All
                    </Button>
                    <Button
                      variant="outline"
                      display="flex"
                      gap="8px"
                      borderRadius="8px"
                      padding="10px 12px"
                      backgroundColor="white"
                      border="1px solid #E0DBD7"
                      size="sm"
                      color="#504C4A"
                      onClick={() => declineCorrections(items, true)}
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 4L4 12"
                          stroke="#E30F0F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M4 4L12 12"
                          stroke="#E30F0F"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                      Reject All
                    </Button>
                  </HStack>
                </HStack>

                {/* Individual items */}
                {openGroups[groupIndex] &&
                  items.map((a, i) => (
                    <Box
                      key={i}
                      p="4"
                      paddingRight="32px"
                      display="flex"
                      justifyContent="space-between"
                      alignItems="center"
                      gap="20px"
                      cursor="pointer"
                      onClick={() => moveToPosition(a.data)}
                      style={{
                        borderBottom: "1px solid #eee",
                      }}
                    >
                      <Box width="calc(100% - 72px)">
                        <Heading
                          fontSize="15px"
                          display="flex"
                          gap="4px"
                          color="#333333"
                          width="100%"
                          whiteSpace="pre-wrap"
                        >
                          <span style={{ color: "red" }}>Deleted: </span>
                          <span
                            style={{
                              wordBreak: " break-all",
                              fontWeight: "600",
                            }}
                          >
                            {a.texts.oldText === " "
                              ? "<space>"
                              : a.texts.oldText.replace(/\n/g, "\\n")}
                          </span>
                        </Heading>
                        {a.texts.newText.trim() && (
                          <Heading
                            fontSize="15px"
                            color="#333333"
                            mt="9px"
                            gap="4px"
                            width="100%"
                            display="flex"
                            whiteSpace="pre-wrap"
                          >
                            <span style={{ color: "green" }}>Added: </span>
                            <span
                              style={{
                                wordBreak: " break-all",
                                fontWeight: "600",
                              }}
                            >
                              {" "}
                              {a.texts.newText === " "
                                ? "<space>"
                                : a.texts.newText.replace(/\n/g, "\\n")}
                            </span>
                          </Heading>
                        )}
                      </Box>
                      <HStack
                        minWidth="86px"
                        justifyContent="flex-end"
                        gap="6px"
                        mb="4px"
                      >
                        <Button
                          size="sm"
                          variant="outline"
                          width="auto"
                          height="fit-content"
                          border="1px solid #DDDDDD"
                          borderRadius="20px"
                          padding="7px"
                          onClick={(e) => {
                            e.stopPropagation();
                            acceptCorrections([a]);
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.3337 4L6.00033 11.3333L2.66699 8"
                              stroke="#208923"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                        <Button
                          size="sm"
                          variant="outline"
                          width="auto"
                          height="fit-content"
                          border="1px solid #DDDDDD"
                          borderRadius="20px"
                          padding="7px"
                          onClick={(e) => {
                            e.stopPropagation();
                            declineCorrections([a]);
                          }}
                        >
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 4L4 12"
                              stroke="#E30F0F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4 4L12 12"
                              stroke="#E30F0F"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </Button>
                      </HStack>
                    </Box>
                  ))}
              </Box>
            </div>
          ))
        ) : (
          <p
            style={{
              padding: "24px",
              fontSize: "20px",
              fontWeight: 500,
              margin: 0,
              color: "rgba(0, 0, 0, 1)",
            }}
          >
            No Suggestions
          </p>
        )}
      </VStack>
    </>
  );
};

const mapStateToProps = (state, ownProps) => ({
  corrections: state.EditTool.EditCorrections,
  rejected: state.editToolRejected.editReject,
  states: state,
  editTool: state.toolStyles.function,
  ace: ownProps.ace,
  currentClient: state.clientSelect.clientselect,
});

const mapDispatchToProps = (dispatch) => {
  return {
    acceptCorrections: (data) =>
      dispatch({ type: "ToolAccept", payload: data }),
    declineCorrections: (data) =>
      dispatch({ type: "ToolReject", payload: data }),
    editToolRejected: () => dispatch({ type: "EmptyReject", payload: [] }),
    toolStyles: (data) => dispatch({ type: "ToolSubmit", payload: data }),
    toolReject: (data) => dispatch({ type: "ToolRejected", payload: data }),
    editToolAction: (data) => dispatch({ type: "EDITTOOL", payload: data }),
    editToolRemove: (data) => dispatch({ type: "TOOLUPDATE", payload: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditCorrections);
